export default __webpack_public_path__ + "static/media/box-background-color-culture.750e3e3d.png";